module.exports = __webpack_public_path__ + "static/img/safeYing.7e00d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/safeYing.png
// module id = UQHR
// module chunks = 2